import Vue from 'vue'
import httpManager from '../../util/common'
import * as d3 from 'd3'

let vm = {
  name: 'ESGEventBarChart',
  delimiters: ['{', '}'],
  data: () => {
    return {
      divloading: false,
      data: null
    }
  },
  methods: {
    PrefixInteger(num, n) {
    return (Array(n).join(0) + num).slice(-n);
},
    getESGData() {
      let self = this
      self.divloading = true
      httpManager("esg_event_statistics")
        .then(response => {
          let midData = {}
          let date = new Date()
          let dateB7=new Date(date.setDate(date.getDate()-8))
          for(let i=1;i<=7;i++){
             let dateTime=new Date(dateB7.setDate(dateB7.getDate()+1));
             let year = dateTime.getFullYear().toString()
              let month = self.PrefixInteger((dateTime.getMonth() + 1),2).toString()
              let d = self.PrefixInteger(dateTime.getDate(),2).toString()
            let dat = year+"-"+month+"-"+d
            midData[dat] = {
                "publish_date": dat,
                "EnvPunishment": 0,
                "BankInsurancePunishment": 0,
                "WorkSafety": 0,
                "MarketPunishment": 0,
                "AntiCorruption": 0,
                "Announcement": 0,
                "SecurityRegulation": 0,
                "NaturalResourcePunishment": 0,
                "TaxationPunishment": 0
              }
          }
          response.data.data.forEach(function (d) {
            if (!midData[d['publish_date']]) {
              midData[d['publish_date']] = {
                "publish_date": d['publish_date'],
                "EnvPunishment": 0,
                "BankInsurancePunishment": 0,
                "WorkSafety": 0,
                "MarketPunishment": 0,
                "AntiCorruption": 0,
                "Announcement": 0,
                "SecurityRegulation": 0,
                "NaturalResourcePunishment": 0,
                "TaxationPunishment": 0
              }
            }
            midData[d['publish_date']][d['sub_type']] = d['num']
            if(d['sub_type'] == "SecurityPunishment" || d['sub_type']=="SecurityRegulatory" || d['sub_type'] == "ExchangeRegulatory")
              midData[d['publish_date']]['SecurityRegulation'] += d['num']
          })
          self.data = [];
          for (let k in midData) {
            self.data.push(midData[k]);
          }
          self.drawChart()
          self.divloading = false
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    },
    drawChart() {
      let self = this
      let tr = {
        NaturalResourcePunishment: this.$t('esg.industry_punishment'),
        TaxationPunishment: this.$t('esg.taxation_punishment'),
        EnvPunishment: this.$t('esg.evironment_supervision'),
        BankInsurancePunishment: this.$t('esg.financial_supervision'),
        WorkSafety: this.$t('esg.production_safety'),
        MarketPunishment: this.$t('esg.market_supervision'),
        AntiCorruption: this.$t('esg.anticorruption'),
        Announcement: this.$t('esg.supply_chain'),
        SecurityRegulation: this.$t('esg.security_supervision')
      }
      let data = Object.assign(self.data)
      let groupKey = 'publish_date'
      let keys = [ 'TaxationPunishment', 'NaturalResourcePunishment', 'EnvPunishment', 'SecurityRegulation', 'BankInsurancePunishment', 'WorkSafety', 'MarketPunishment', 'AntiCorruption', 'Announcement']
      let color = d3.scaleOrdinal().range(["#FF6347", "#1E90FF", "#141A1E", "#6d5de1", "#C92525", "#E1B93C", "#4563B3", "#47964b", "#8add33"])
      d3.select("#esg_event_bar_chart").select('*').remove()
      let height = 310
      let width = 440
      let svg = d3.select("#esg_event_bar_chart").append("svg").attr("viewBox", [-30, 0, width+100, height])
      let margin = ({top: 40, right: 17, bottom: 41, left: 52})
      let xAxis = g => g
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x0).tickSizeOuter(0))
        .call(g => g.selectAll(".tick text").attr('transform','translate(-25,13)rotate(-30)'))
        // .call(g => g.select(".domain").remove())
      let yAxis = g => g
        .attr("transform", `translate(${margin.left},0)`)
        .call(d3.axisLeft(y).ticks(null, "s"))
        .call(g => g.select(".domain").remove())
        .call(g => g.select(".tick:last-of-type text").clone()
          .attr("x", 3)
          .attr("text-anchor", "start")
          .attr("font-weight", "bold")
          .text(data.y))
      let x0 = d3.scaleBand()
        .domain(data.map(d => d[groupKey]))
        .rangeRound([margin.left, width - margin.right])
        .paddingInner(0.1)
      let x1 = d3.scaleBand()
        .domain(keys)
        .rangeRound([0, x0.bandwidth()])
        .padding(0.05)
      let y = d3.scaleLinear()
        .domain([0, d3.max(data, d => d3.max(keys, key => d[key]))]).nice()
        .rangeRound([height - margin.bottom, margin.top])

      let legend = svg => {
        const g = svg
          .attr("transform", `translate( ${width + 70},0)`)
          .attr("text-anchor", "end")
          .attr("font-family", "sans-serif")
          .attr("font-size", 14)
          .selectAll("g")
          .data(color.domain().slice().reverse())
          .join("g")
          .attr("transform", (d, i) => `translate(0,${i * 20})`);

        g.append("rect")
          .attr("x", -19)
          .attr("width", 19)
          .attr("height", 19)
          .attr("fill", color);

        g.append("text")
          .attr("x", -24)
          .attr("y", 9.5)
          .attr("dy", "0.35em")
          .text(d => tr[d]);


      }
      svg.append("g")
        .selectAll("g")
        .data(data)
        .join("g")
        .attr("transform", d => `translate(${x0(d[groupKey])},0)`)
        .selectAll("rect")
        .data(d => keys.map(key => ({key, value: d[key]})))
        .join("rect")
        .attr("x", d => x1(d.key))
        .attr("y", d => y(d.value))
        .attr("width", x1.bandwidth())
        .attr("height", d => y(0) - y(d.value))
        .attr("fill", d => color(d.key));

      svg.append("g").call(xAxis);
      svg.append("g").call(yAxis);
      svg.append("g").call(legend);
      svg.node();
    }

  },
  mounted() {
    this.getESGData()
  },
}
Vue.component("esg-event-bar-chart", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_event_bar_chart.js